var exports = {
  "f": "section-title__DFzdeO",
};

module.exports = exports;
